/**
 * Gets value from object using dot-notation path.
 * 
 * Args:
 *     obj: Object to traverse
 *     path: Dot-separated path string
 * 
 * Returns:
 *     Value at path or undefined if not found
 */
export function getByPath(obj: any, path: string): any {
  if (!obj || !path) return undefined;
  const parts = path.split('.').filter(Boolean);
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

/**
 * Sets value in object using dot-notation path.
 * 
 * Args:
 *     obj: Object to modify (or null/undefined)
 *     path: Dot-separated path string
 *     value: Value to set
 * 
 * Returns:
 *     Modified object with value set at path
 */
export function setByPath(obj: any, path: string, value: any): any {
  const parts = path.split('.').filter(Boolean);
  const root = obj ?? {};
  let cur = root;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    cur[p] = cur[p] ?? {};
    cur = cur[p];
  }
  cur[parts[parts.length - 1]] = value;
  return root;
}
